import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { Box, Toolbar, List, ListItem, Icon, Tooltip, IconButton } from "@mui/material";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";

const AppSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const projectId = searchParams.get("id");

  const modules = [
    {
      name: "projects",
      labelName: "Projects",
      icon: <FolderOutlinedIcon />,
      onClick: () => {
        navigate({
          pathname: `/modules/projects`,
        });
        window.localStorage.removeItem("project");
      },
    },
    {
      name: "information",
      labelName: "Information",
      icon: <InfoOutlinedIcon />,
    },
    {
      name: "data",
      labelName: "Data",
      icon: <TableChartOutlinedIcon />,
    },
  ];

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        right: 0,
        width: 80,
        height: "100%",
        zIndex: 1000,
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
      }}
    >
      <Toolbar />
      <List
        sx={{
          height: "calc(100vh - 64px)",
        }}
      >
        {(projectId ? modules : [modules[0]]).map((module, index) => (
          <ListItem
            key={module.name}
            sx={{
              p: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Tooltip title={module.labelName} placement="left" arrow>
              <IconButton
                onClick={() => {
                  if (module.onClick) {
                    module.onClick();
                  } else {
                    navigate({
                      pathname: `/modules/${module.name}`,
                      search: location.search,
                    });
                  }
                }}
              >
                {module.icon}
              </IconButton>
            </Tooltip>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default AppSidebar;
